import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { VerifyCodeService } from './verify-code.service';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { AuthStatus } from '../../../core/models/auth.model';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const verifyCodeService = inject(VerifyCodeService);
  const authService = inject(AuthService);

  if (!authService.accessToken()) return next(req);

  if (
    !verifyCodeService.isFirstlog() &&
    authService.authStatus() !== AuthStatus.authenticated
  )
    return next(req);

  const reqWithAccessToken = req.clone({
    headers: req.headers.append(
      'Authorization',
      `Bearer ${authService.accessToken()}`,
    ),
  });

  return next(reqWithAccessToken).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        error.status === HttpStatusCode.Unauthorized ||
        error.status === HttpStatusCode.Forbidden
      ) {
        authService.logout();
      }
      return throwError(() => error);
    }),
  );
};
